module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "public-nav-layout"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('ul', {
    staticClass: "site-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "index"
    }
  }, [_vm._v("首页")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "enterprise-brand-store",
      "target": "_blank"
    }
  }, [_vm._v("企业网店")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "gold-shop"
    }
  }, [_vm._v("金牌网店")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "silver-shop"
    }
  }, [_vm._v("银牌网店")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "personal-shop"
    }
  }, [_vm._v("个体网店")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/recommend-goods?type=8",
      "target": "_blank"
    }
  }, [_vm._v("自营积分专区")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/recommend-goods?type=4",
      "target": "_blank"
    }
  }, [_vm._v("现金劵专区")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/fresh-agricultural",
      "target": "_blank"
    }
  }, [_vm._v("农特生鲜")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/china-time-honored",
      "target": "_blank"
    }
  }, [_vm._v("中华老字号")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/landmark-superior-product",
      "target": "_blank"
    }
  }, [_vm._v("地标优品")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/same-city-businesses"
    }
  }, [_vm._v("同城商家")])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ee23de5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/category-menu-old.vue
// module id = 1676
// module chunks = 1